<template>
  <div id="page-strategy-view">
    <vx-title-bar :route="$route" :isRTL="$vs.rtl">
      <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
        <vs-button radius icon="icon-more-vertical" icon-pack="feather" />
        <vs-dropdown-menu>
          <vs-dropdown-item>
            <div @click="editRecord" class="flex items-center">
              <feather-icon icon="EditIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
              <span>{{this.$t("Edit")}}</span>
            </div>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vx-title-bar>
    <vs-alert color="danger" title="Strategy Not Found" :active.sync="strategy_not_found">
      <span>
        Strategy record with id
        <strong>{{ $route.params.strategyId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{name:'strategy-list'}"
          class="text-inherit underline"
        >{{this.$t("strategy.List")}}</router-link>
      </span>
    </vs-alert>

    <div id="strategy-data" v-if="strategy_data">
      <vx-card :title="this.$t('strategy.Title')" class="mb-base">
        <!-- strategy -->
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{this.$t("strategy.Name")}}</td>
                <td>{{ strategy_data.name }}</td>
              </tr>
            </table>
          </div>
          <!-- Log Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="strategy_data.logoUrl" class="rounded w-full" />
            </div>
          </div>
        </div>
      </vx-card>
      <!-- <vx-card :title="this.$t(`strategy.Strategies${this.strategy_data.idStrategyType}`)" class="mb-base">
        <strategy-list :idstrategy="strategy_data.id" />
      </vx-card> -->
    </div>
  </div>
</template>

<script>
import moduleStrategyManagement from '@/store/strategy-management/moduleStrategyManagement.js'
// import StrategyList from './StrategyList'

export default {
  data () {
    return {
      strategy_data: null,
      strategy_not_found: false
    }
  },
  components : {
    // StrategyList
  },
  methods: {
     editRecord () {
        this.$router.push(`/strategy/edit/${this.strategy_data.id}`).catch(() => {})
    }
  },
  created () {
    if (!moduleStrategyManagement.isRegistered) {
      this.$store.registerModule('strategyManagement', moduleStrategyManagement)
      moduleStrategyManagement.isRegistered = true
    }

    const strategyId = this.$route.params.strategyId
    this.$store.dispatch('strategyManagement/fetchstrategy', strategyId)
      .then(res => {
        this.strategy_data = res.data.strategy
        if (this.strategy_data === null) {
          this.strategy_not_found = true
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.strategy_not_found = true
          return
        }
        console.error(err)
      })
  }
}

</script>
